// ---------------------------------
//  Imports
// ---------------------------------

import { gsap } from "gsap";

// ---------------------------------
//  Global letiables
// ---------------------------------

const quoteModule = document.querySelector("#tech-quote-module");

// ---------------------------------
//  Tech Module
// ---------------------------------

if (false && quoteModule) {
  console.log("Tech Quote Module");

  // -------------- Stage Controller -----------

  // Variables -----------

  const quoteStagesWrap = document.querySelector(".quote-stages");
  const quoteStages = document.querySelectorAll(".quote-stage");
  const allOptions = quoteStagesWrap.querySelectorAll(".option");
  const allTabs = document.querySelectorAll(".navigation-tab");
  const app = document.querySelector("#app");
  const theURL = window.location.href;
  let closeBtn;
  let stageIndex = 1;
  let dur = 0.6;

  // Utility Functions -----------

  const hasQueryParams = (url) => {
    return url.includes("?");
  };

  const countQueryParams = (url) => {
    let count = 1;

    for (let i = 0; i < url.length; i++) {
      if (url[i] === "?") {
        count++;
      }
      if (url[i] === "&") {
        count++;
      }
    }

    return count;
  };

  // Functions -----------

  const updateURL = () => {
    // Update URL here
    console.log("update URL");
  };

  const updateNumbers = (el, numberTo) => {
    // Tick up number
    gsap.to(el, {
      innerText: numberTo,
      duration: 0.8,
      snap: {
        innerText: 1,
      },
    });
  };

  const adjustStageHeight = (el, duration = dur) => {
    let newHeight = el.offsetHeight;
    gsap.to(quoteStagesWrap, {
      duration: duration,
      height: newHeight,
      ease: "expo.inOut",
    });
    if (duration > 0 && document.body.clientWidth < 768) {
      setTimeout(() => {
        window.scrollTo({
          top: 245,
          behavior: "instant",
        });
      }, 200);
    }
  };

  // Clean up selected options and output
  const cleanUpClasses = () => {
    let currentlyActiveOutput = document.querySelector(".activate-output");
    let currentlyActiveIssue = document.querySelector(".active-issue");

    updateNumbers(".day-num", 0);
    updateNumbers(".price-num", 0);

    if (currentlyActiveOutput)
      currentlyActiveOutput.classList.remove("activate-output");
    if (currentlyActiveIssue)
      currentlyActiveIssue.classList.remove("active-issue");
  };

  const updateNavigation = (index) => {
    let activeTab = document.querySelector(".active-tab");
    let targetTab = document.querySelector(`[data-stage-tab="${index}"]`);

    // Hide old active stage if present
    if (activeTab) activeTab.classList.remove("active-tab");

    // Reveal target stage
    targetTab.classList.add("active-tab");

    // Complete Tabs
    Array.from(allTabs).forEach((tab, i) => {
      if (i < index - 1) {
        // <- -1 for true index
        tab.classList.add("completed-tab");
      } else {
        tab.classList.remove("completed-tab");
      }
    });

    cleanUpClasses();
  };

  const revealStage = (index) => {
    let activeStage = document.querySelector(".active-stage");
    let targetStage = document.querySelector(`[data-stage="${index}"]`);

    // Hide old active stage if present
    if (activeStage) activeStage.classList.remove("active-stage");

    // Reveal target stage
    targetStage.classList.add("active-stage");
  };

  const activateStage = (index, initState = false) => {
    let heightDur = dur;
    if (initState) heightDur = 0;
    adjustStageHeight(quoteStages[index - 1], heightDur); // -1 for true index
    revealStage(index);
    updateNavigation(index);
  };

  // Handler -----------

  if (quoteStages) {
    const stageNavigation = document.querySelector("#quote-navigation");

    if (hasQueryParams(theURL)) {
      // Has params
      activateStage(countQueryParams(theURL)); // <- Load stage based on query params
    } else {
      // Has no params
      activateStage(1, true); // <- Force load stage 1
    }
  }

  // Options & Selections -----------

  Array.from(allOptions).forEach((option) => {
    option.onclick = (e) => {
      e.preventDefault();

      let parentStage = option.closest(".quote-stage");
      let parentStageIndex = Number(parentStage.dataset.stage);

      console.log("parentStage", parentStage);
      console.log("parentStageIndex", parentStageIndex);
      console.log("parentStageIndex + 1", parentStageIndex + 1);

      activateStage(parentStageIndex + 1);
      updateURL();
    };
  });

  Array.from(allTabs).forEach((tab, index) => {
    tab.onclick = (e) => {
      e.preventDefault();
      revealStage(index + 1);
      updateNavigation(index + 1);
      adjustStageHeight(quoteStages[index + 1], dur);
      updateURL();
    };
  });

  // -------------- Problem Stage --------------
  /*
  const issuesList = document.querySelector(".issues-list");
  const quoteResult = document.querySelector(".quote-result");
  if (issuesList) {
    const allIssues = issuesList.querySelectorAll(".issue");

    const updateQuoteOutput = (el) => {
      let days = el.dataset.days;
      let cost = el.dataset.cost;
      console.log("Update quote output");
      quoteResult.classList.add("activate-output");
      updateNumbers(".day-num", days);
      updateNumbers(".price-num", cost);
    };

    const activeClassController = (event, el) => {
      event.preventDefault();

      if (el.classList.contains("active-issue")) {
        el.classList.remove("active-issue");
        cleanUpClasses();
      } else {
        let activeIssue = issuesList.querySelector(".active-issue");
        if (activeIssue) {
          console.log("active issue");
          activeIssue.classList.remove("active-issue");
        }
        el.classList.toggle("active-issue");
        updateQuoteOutput(el);
      }
    };

    const closeModal = (event) => {
      event.preventDefault();
      let activeModal = document.querySelector(".active-modal");
      if (activeModal) activeModal.classList.remove("active-modal");
      app.classList.remove("modal-activated");
      document.body.classList.remove("hide-scroll");
      closeBtn.removeEventListener("click", closeModal);
    };

    // If ESC is pressed close modal
    document.addEventListener("keydown", (evt) => {
      if (evt.key === "Escape" || evt.keyCode === 27) {
        closeModal(evt);
      }
    });

    const openModal = () => {
      let modal = document.querySelector(".modal");
      closeBtn = modal.querySelector(".close-modal");
      modal.classList.add("active-modal");
      app.classList.add("modal-activated");
      document.body.classList.add("hide-scroll");

      closeBtn.addEventListener("click", closeModal);
    };

    Array.from(allIssues).forEach((issue) => {
      issue.onclick = (e) => activeClassController(e, issue);
      let tooltipLink = issue.querySelector(".tooltip");
      tooltipLink.onclick = (e) => {
        e.preventDefault();
        openModal();
      };
    });
  }
  */
}
